// Schedules.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Schedules() {
    return (
        <PageLayout title="Schedules" subtitle="Schedules overview">
            <div className="container flex col box-container">
                {/* <div className="box">Schedules</div> */}
            </div>
        </PageLayout>   
    );
}

export default Schedules;
